import { css, Global } from '@emotion/react';

import { boxShadow, colors, fonts } from './theme';

const GlobalStyles = () => {
  return (
    <Global
      styles={css`
        body {
          * {
            color: ${colors.text1};
          }
        }
        input {
          box-shadow: none !important;
        }
        h1,
        .h1 {
          font-family: ${fonts.InterBold};
          font-size: 20px;
          line-height: 24px;

          &.light {
            font-family: ${fonts.InterRegular};
          }

          @media (min-width: 640px) {
            font-size: 24px;
            line-height: 29px;
          }
          @media (min-width: 1024px) {
            font-size: 32px;
            line-height: 38px;
          }

          &.page-heading {
            font-size: 20px;
            line-height: 24px;
            @media (min-width: 640px) {
              font-size: 24px;
              line-height: 29px;
            }
            @media (min-width: 1024px) {
              font-size: 32px;
              line-height: 38px;
            }
          }
        }
        h2,
        .h2 {
          font-family: ${fonts.InterBold};
          font-size: 18px;
          line-height: 22px;
          &.light {
            font-family: ${fonts.InterRegular};
          }
          @media (min-width: 640px) {
            font-size: 20px;
            line-height: 24px;
          }
          @media (min-width: 1024px) {
            font-size: 25px;
            line-height: 28px;
          }
        }
        h3,
        .h3 {
          font-family: ${fonts.InterBold};
          font-size: 24px;
          line-height: 29.05px;
          &.light {
            font-family: ${fonts.InterRegular};
          }
        }
        h4,
        .h4 {
          font-family: ${fonts.InterMedium};
          font-size: 16px;
          line-height: 24px;
          &.light {
            font-family: ${fonts.InterRegular};
          }
        }
        h5,
        .h5 {
          font-family: ${fonts.InterBold};
          font-size: 12.8px;
          line-height: 20px;
        }
        p {
          font-size: 14px;
          line-height: 16.94px;
          font-family: ${fonts.InterSemiBold};

          @media (min-width: 640px) {
            font-size: 16px;
            line-height: 19.36px;
          }

          &.small {
            font-size: 12px;
            line-height: 14.52px;
            @media (min-width: 640px) {
              font-size: 14px;
              line-height: 16.94px;
            }
          }
          &.big {
            font-size: 16px;
            line-height: 22px;
            @media (min-width: 640px) {
              font-size: 18px;
              line-height: 26px;
            }
          }
          &.tiny {
            font-size: 10px;
            line-height: 12px;
            @media (min-width: 640px) {
              font-size: 12px;
              line-height: 14.52px;
            }
          }
          &.light {
            font-family: ${fonts.InterRegular};
          }
          &.medium {
            font-family: ${fonts.InterMedium};
          }
          &.bold {
            font-family: ${fonts.InterBold};
          }
          &.inline {
            display: inline;
          }
          &.avatar-large {
            font-size: 24px;
            line-height: 28px;
            @media (min-width: 640px) {
              font-size: 28px;
              line-height: 32px;
            }
            @media (min-width: 1024px) {
              font-size: 32px;
              line-height: 36px;
            }
          }
          &.avatar-small {
            font-size: 10px;
            line-height: 12px;
            @media (min-width: 640px) {
              font-size: 12px;
              line-height: 14px;
            }
          }
        }
        a {
          text-decoration: underline;
          &:hover {
            color: ${colors.primary};
            text-decoration: underline;
          }
        }
        .ant-btn:not(.ant-btn-link) {
          font-size: 14px;
          border-radius: 5px;
          min-height: 35px;
          height: 35px;
          white-space: break-spaces;
          padding: 8px 16px;
          font-family: ${fonts.InterRegular};
          &.primary:not(:disabled, .primaryDisabled) {
            background-color: ${colors.primary};
            border-color: ${colors.primary};
            &:hover {
              background-color: ${colors.primaryLight};
              border-color: ${colors.primaryLight};
            }
            & > span {
              color: white !important;
            }
          }
          &.ant-btn-default {
            border-color: ${colors.primary};
            &:hover {
              border-color: ${colors.primary};
            }
          }
          &.ant-btn-primary {
            & > span {
              color: white !important;
            }
          }
          &:disabled {
            background-color: ${colors.lightGray};
            border-color: ${colors.darkenGraySecondary};
            & * {
              color: ${colors.text1};
            }
            svg > path {
              fill: ${colors.text1};
            }
          }
          &.small {
            height: 24px !important;
            min-height: 24px !important;
            max-height: 24px !important;
            padding: 8px !important;

            & * {
              font-size: 14px !important;
            }
          }

          &.medium {
            height: 32px !important;
            min-height: 32px !important;
            max-height: 32px !important;
            padding: 8px !important;
          }

          &.small-icon {
            height: 24px !important;
            min-height: 24px !important;
            max-height: 24px !important;
            min-width: auto !important;
            padding: 4px !important;
          }
          & * {
            line-height: 20px;
          }
          &.icon {
            padding: 1px 3px;
            min-height: 32px;
            max-height: 32px;
            min-width: 32px;
            &:disabled {
              & > svg > path {
                fill: ${colors.text1};
              }
            }
            & > .ant-btn-loading-icon {
              position: absolute;
            }
            &.big {
              min-height: 40px;
              min-width: 40px;
            }
          }
        }
        .ant-btn-link {
          padding: 0px;
          height: unset;
          & > span {
            text-decoration: underline;
            font-family: ${fonts.InterRegular};
          }
          &.small {
            & * {
              font-size: 12.8px;
            }
          }
          &:hover {
            & * {
              color: ${colors.text1};
            }
          }
          &:not(:disabled, .ant-btn-loading):hover {
            & * {
              color: ${colors.primary} !important;
            }
          }
        }
        .primary .ant-btn-loading,
        .tertiary .ant-btn-loading {
          & > .ant-btn-loading-icon {
            & path {
              color: ${colors.lightGray};
            }
          }
        }
        .ant-notification {
          & .ant-notification-notice {
            padding: 0px !important;
            border-radius: 4px;
            box-shadow: ${boxShadow[100]};
            border: 1px solid ${colors.darkenGraySecondary};
            & .ant-notification-notice-message {
              margin-bottom: 0px !important;
              margin-inline-start: 0px !important;
              padding: 14px 0px;
              padding-left: 14px;
              padding-inline-end: 38px !important;
              @media (max-width: 768px) {
                padding-left: 6px;
                padding: 8px;
                padding-inline-end: 12px !important;
              }
            }
          }
          & .ant-notification-notice-close {
            top: 16px !important;
            right: 16px !important;
          }
          & .ant-notification-notice-success {
            border-left: 4px solid ${colors.success};
          }
          & .ant-notification-notice-info {
            border-left: 4px solid ${colors.skyBlue};
          }
          & .ant-notification-notice-warning {
            border-left: 4px solid ${colors.warning};
          }
          & .ant-notification-notice-error {
            border-left: 4px solid ${colors.error};
          }
          & .anticon {
            display: none;
          }
        }
        .ant-alert {
          background-color: white !important;
          box-shadow: ${boxShadow[100]};
          border-radius: 8px !important;
          border: 1px solid ${colors.darkenGraySecondary};
          padding: 12px 16px;
          padding-left: 12px;
          align-items: unset;

          &.small {
            padding: 8px 12px !important;
          }

          @media (max-width: 768px) {
            padding: 4px 8px !important;
          }

          &.ant-alert-info {
            border-left: 6px solid ${colors.blueInput};
            & .ant-alert-icon svg path {
              fill: ${colors.blueInput} !important;
            }
          }
          &.ant-alert-warning {
            border-left: 6px solid ${colors.warning};
            & .ant-alert-icon svg path {
              fill: ${colors.warning} !important;
            }
          }
          &.ant-alert-error {
            border-left: 6px solid ${colors.error};
            & .ant-alert-icon svg path {
              fill: ${colors.error} !important;
            }
          }
          &.ant-alert-success {
            border-left: 6px solid ${colors.success};
            & .ant-alert-icon svg path {
              fill: ${colors.success} !important;
            }
          }
          & .ant-alert-close-icon {
            display: flex;
            height: fit-content;
            & svg > path {
              fill: ${colors.text1} !important;
            }
          }
        }
        .ant-form-item:not(.switchItem, .switchItemSmall) {
          margin-bottom: 20px;
          &.hide-label {
            .ant-form-item-label {
              display: none;
            }
          }
          .ant-form-item-explain-error {
            font-size: 12.8px;
            color: ${colors.error};
          }
        }
        .ant-modal-root {
          & .ant-modal-confirm-btns {
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: flex-end;
            svg {
              path {
                fill: white;
              }
            }
          }
          & .ant-modal-mask {
          }
          & .ant-modal-wrap {
            & .ant-modal {
              & .ant-modal-content {
                padding: 0;
                border: 1px solid ${colors.darkenGraySecondary};
                border-radius: 8px;
                & .ant-modal-close {
                  top: 24px;
                  right: 24px;
                }
                & .ant-modal-header {
                  padding: 24px 24px 0 24px;
                  margin-bottom: 0;
                  border-bottom: 0;
                  & .ant-modal-title {
                    font-family: ${fonts.InterBold};
                    font-size: 18px;
                    line-height: 22px;
                    font-weight: 700;
                    @media (min-width: 1024px) {
                      font-size: 24px;
                      line-height: 29px;
                    }
                  }
                }
                & .ant-modal-body {
                  padding: 24px;
                  font-size: 16px;
                  line-height: 24px;
                }
                & .ant-modal-footer {
                  padding: 0 24px 24px 24px;
                }
              }
            }
          }
        }

        @media (max-width: 767px) {
          .ant-modal-root {
            & .ant-modal-wrap {
              padding: 0 !important;
              & .ant-modal {
                width: 100% !important;
                max-width: 100% !important;
                margin: 0 !important;
                left: 0 !important;
                right: 0 !important;
                top: 50% !important;
                transform: translateY(-50%) !important;
                padding-bottom: 0 !important;
                & .ant-modal-content {
                  max-height: 70vh;
                  display: flex;
                  flex-direction: column;
                  & .ant-modal-close {
                    top: 16px;
                    right: 16px;
                  }
                  & .ant-modal-header {
                    padding: 16px;
                    flex-shrink: 0;
                    & .ant-modal-title {
                      font-size: 18px;
                      line-height: 22px;
                    }
                  }
                  & .ant-modal-body {
                    padding: 16px;
                    font-size: 14px;
                    line-height: 20px;
                    flex: 1;
                    overflow-y: auto;
                    -webkit-overflow-scrolling: touch;
                  }
                  & .ant-modal-footer {
                    padding: 16px;
                    flex-shrink: 0;
                    border-top: 1px solid ${colors.darkenGraySecondary};
                    & .ant-btn {
                      width: 100%;
                      margin: 0;
                      &:not(:last-child) {
                        margin-bottom: 8px;
                      }
                    }
                  }
                }
              }
            }
            & .ant-modal-confirm-btns {
              flex-direction: column;
              gap: 8px;
              & .ant-btn {
                width: 100%;
                margin: 0;
              }
            }
          }
        }
        .responsive-drawer {
          & .ant-drawer-content {
            border-left: 1px solid ${colors.darkenGraySecondary};
          }
          & .ant-drawer-header {
            padding: 24px;
            border-bottom: 1px solid ${colors.darkenGraySecondary};
            & .ant-drawer-header-title {
              flex-direction: row-reverse;
              & .ant-drawer-close {
                margin-inline-end: 0;
                margin-inline-start: 8px;
                align-self: flex-start;
              }
            }
            & .ant-drawer-title {
              font-family: ${fonts.InterBold};
              font-size: 18px;
              line-height: 22px;
              font-weight: 700;
            }
          }
          & .ant-drawer-body {
            padding: 24px;
            font-size: 16px;
            line-height: 24px;
            background-color: #f7f8fa;
          }
          & .ant-drawer-footer {
            padding: 16px 24px;
            border-top: 1px solid ${colors.darkenGraySecondary};
          }
        }

        @media (max-width: 767px) {
          .responsive-drawer {
            & .ant-drawer-content-wrapper {
              width: 100% !important;
              max-width: 100% !important;
            }
            & .ant-drawer-header {
              padding: 16px;
            }
            & .ant-drawer-body {
              padding: 16px;
              font-size: 14px;
              line-height: 20px;
            }
            & .ant-drawer-footer {
              padding: 16px;
              & .ant-btn {
                width: 100%;
                margin: 0;
                &:not(:last-child) {
                  margin-bottom: 8px;
                }
              }
            }
          }
        }
        .ant-tabs {
          & .ant-tabs-nav-wrap {
            background-color: ${colors.lightGray};
            padding: 0 12px;
          }
        }

        .kendo-table-foco.k-treelist-scrollable,
        .k-treelist-scrollable.kendo-table-foco,
        div.kendo-table-foco.k-treelist-scrollable,
        .k-treelist.kendo-table-foco {
          border-radius: 4px !important;
          width: 100% !important;
          overflow-y: auto !important;
          overflow-x: auto !important;
          font-size: 14px !important;
          font-family: 'Inter-Regular' !important;

          &::-webkit-scrollbar {
            width: 12px !important;
            height: 12px !important;

            &:hover {
              width: 12px !important;
              height: 12px !important;
              cursor: pointer !important;
            }
          }

          /* Track */
          &::-webkit-scrollbar-track {
            background: #e5e5ea !important;
          }

          /* Handle */
          &::-webkit-scrollbar-thumb {
            background-color: #575757 !important;
            background: rgba(45, 45, 45, 0.5) !important;
            opacity: 0.5 !important;
            border-radius: 4px !important;
          }

          /* Handle on hover */
          &::-webkit-scrollbar-thumb:hover {
            cursor: pointer !important;
          }

          table {
            width: 100% !important;
            border-collapse: collapse !important;
            table-layout: fixed !important;

            tr:hover .k-grid-header-sticky,
            tr:hover .k-grid-footer-sticky,
            tr.k-state-hover .k-grid-header-sticky,
            tr.k-state-hover .k-grid-footer-sticky {
              background: #fff !important;
            }

            th {
              padding: 4px 8px !important;
              &:last-child {
                border-right: none !important;
              }
            }
            .k-grid-header .k-sorted,
            .k-grid-header .k-link:hover {
              color: black !important;
            }

            tbody {
              td {
                font-size: 14px !important;
                font-family: ${fonts.InterSemiBold} !important;
                padding: 1px 12px !important;
                overflow: hidden !important;
                background-color: white !important;
                &:last-child {
                  border-right: none !important;
                }
                &.without-padding {
                  padding: 0 !important;
                }
              }
            }
            thead.k-grid-header {
              th.k-header {
                z-index: 996 !important;
                text-align: left !important;
                min-height: 52px !important;
                max-height: 104px !important;
                vertical-align: middle !important;
                color: black !important;
                background-color: ${colors.lightGray} !important;
                padding: 0 !important;
                &:last-child {
                  border-right: none !important;
                }

                * {
                  font-size: 14px !important;
                  font-family: ${fonts.InterSemiBold} !important;
                }

                .k-link {
                  cursor: default !important;
                  margin: 0 !important;
                  padding: 16px !important;
                  line-height: 16px !important;
                  display: flex !important;
                  justify-content: flex-start !important;
                }
                .k-column-title {
                }
                .k-cell-inner {
                  max-width: 100% !important;
                  margin: 0 !important;
                }
              }
            }
          }

          &.bordered {
            border: 1px solid ${colors.darkenGraySecondary} !important;
            box-sizing: border-box !important;
            table {
              width: 100% !important;
              box-sizing: border-box !important;
              max-width: 100% !important;
              th {
                border-right: 1px solid ${colors.darkenGraySecondary} !important;
                box-sizing: border-box !important;
              }
              tbody {
                td {
                  border-right: 1px solid ${colors.darkenGraySecondary} !important;
                  border-bottom: 1px solid ${colors.darkenGraySecondary} !important;
                  box-sizing: border-box !important;
                }
              }
              thead.k-grid-header {
                th.k-header {
                  border-right: 1px solid ${colors.darkenGraySecondary} !important;
                  border-bottom: 1px solid ${colors.darkenGraySecondary} !important;
                  box-sizing: border-box !important;
                }
              }
            }
          }

          &.loading {
            opacity: 0.4 !important;
            z-index: 1 !important;
            &:after {
              content: 'Cargando...' !important;
              font-size: 12px !important;
              position: absolute !important;
              top: 50% !important;
              left: 50% !important;
              transform: translate(-50%, 0) !important;
              z-index: 2 !important;
              color: #000 !important;
              font-weight: 600 !important;
            }

            .k-grid-norecords {
              opacity: 0 !important;
            }
          }
          &.header-compact {
            table {
              thead.k-grid-header {
                th.k-header {
                  min-height: 26px !important;
                  max-height: 26px !important;
                  padding: 0px 8px !important;
                  .k-link {
                    padding: 5px 0px !important;
                  }
                }
              }
            }
          }

          &.without-hover-bg {
            table {
              .k-master-row:hover .k-grid-content-sticky,
              .k-master-row:hover .k-grid-row-sticky,
              .k-master-row.k-state-hover .k-grid-content-sticky,
              .k-master-row.k-state-hover .k-grid-row-sticky {
                background-color: transparent !important;
              }
            }
          }

          &.light {
            table {
              tbody {
                td {
                  font-family: ${fonts.InterLight} !important;
                }
              }
            }
          }

          &.regular {
            table {
              tbody {
                td {
                  font-family: ${fonts.InterRegular} !important;
                }
              }
            }
          }

          &.medium {
            table {
              tbody {
                td {
                  font-family: ${fonts.InterMedium} !important;
                }
              }
            }
          }

          &.bold {
            table {
              tbody {
                td {
                  font-family: ${fonts.InterBold} !important;
                }
              }
            }
          }
        }
        .tree-list-loading {
          .kendo-table-foco {
            table {
              tbody {
                tr.k-grid-norecords {
                  td {
                    padding: 0 !important;
                  }
                }
              }
            }
          }
          .k-treelist {
            table {
              tbody {
                tr.k-grid-norecords {
                  td {
                    padding: 0 !important;
                  }
                }
              }
            }
          }
        }

        .ant-tooltip {
          min-width: 402px;

          &.max-content {
            min-width: max-content;
          }

          @media (max-width: $mobileScreen) {
            min-width: calc(100vw - 32px);
          }
          .ant-tooltip-content {
            background: white;
            box-shadow: 0px 0px 40px rgba(0, 0, 0, 0.42);
            border-radius: 5px;
            padding: 16px;

            .ant-tooltip-inner {
              background: white;
              color: black;
              box-shadow: none;

              .title {
                font-family: 'Inter-Bold' !important;
                font-size: 14px !important;
                border-bottom: 1px solid ${colors.darkenGraySecondary};
                padding-bottom: 8px;
                margin-bottom: 8px;
              }

              .subtitle {
                font-family: 'Inter-Regular';
                font-size: 14px;
              }

              .version {
                font-family: 'Inter-Regular';
                font-size: 10px;
                margin-top: 4px;
              }
            }
          }
          .ant-tooltip-arrow {
            &::before,
            &::after {
              background: white !important;
            }
          }
        }
        .ant-checkbox-wrapper {
          &.circular {
            & .ant-checkbox-inner {
              border-radius: 20px;
            }
          }
        }
        .foco-select {
          .ant-select {
            & .ant-select-selector {
              border-radius: 5px;
              border: 1px solid ${colors.primary};
            }

            &.ant-select-multiple:not(.small) {
              overflow: hidden;
              max-height: 35px;
              & .ant-select-selection-wrap {
                & .ant-select-selection-overflow {
                  & .ant-select-selection-item {
                    max-width: 100%;
                    text-overflow: ellipsis;
                    overflow: hidden;
                    white-space: nowrap;
                    font-size: 11px;
                    font-family: ${fonts.InterRegular};
                  }
                }
              }
            }

            &.small {
              height: 24px !important;
              min-height: 24px !important;
              max-height: 24px !important;
              & .ant-select-selection-wrap {
                padding: 12px !important;
              }
              & .ant-select-selector {
                height: 24px !important;
                padding: 8px !important;
              }
              &.ant-select-multiple {
                & .ant-select-selection-wrap {
                  max-height: 24px !important;
                  overflow: hidden;
                  padding: 0 !important;
                  position: relative;
                  top: -10px;
                  display: flex;
                  flex-wrap: wrap;
                }
                & .ant-select-selection-item {
                  border-radius: 4px !important;
                  padding: 1px !important;
                  font-size: 9px !important;
                  font-family: ${fonts.InterBold} !important;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  & .anticon-close {
                    font-size: 8px !important;
                  }
                }
              }
            }
          }
        }

        .ant-switch {
          &.ant-switch-small {
            min-width: 18px;
            width: 26px;
            height: 16px;
            border: 2px solid;
            box-sizing: border-box;
            background-color: white;
            &:hover {
              background-color: white !important;
            }
            .ant-switch-handle {
              width: 10px;
              height: 10px;
              position: relative;
              top: 1px;
              border-radius: 50%;
              &::before {
                background-color: black;
              }
            }
            &.ant-switch-checked {
              background-color: white;
              border-color: ${colors.primary};
              .ant-switch-handle {
                background-color: white;
                position: relative;
                left: 10px;
                &::before {
                  background-color: ${colors.primary};
                }
                &:hover {
                  background-color: ${colors.primary};
                  &::before {
                    background-color: ${colors.primary};
                  }
                }
              }
            }
          }
        }
        .k-grid {
          .k-grid-aria-root {
            .k-grid-header {
              th.k-table-th {
                background-color: ${colors.lightGray} !important;
                font-size: 14px !important;
                font-family: ${fonts.InterSemiBold} !important;
              }
            }
          }
          .k-grid-norecords-template {
            width: 100% !important;
          }
          .k-grid-container {
            table.k-table {
              tbody {
                tr.k-table-row {
                  &.k-table-alt-row {
                    background-color: white !important;
                  }
                  td.k-table-td {
                    background-color: white !important;
                    padding: 1px 12px !important;
                    box-sizing: border-box !important;
                    border-bottom: 1px solid ${colors.darkenGraySecondary} !important;
                  }
                }
              }
            }
          }
        }
        .scroll-bar-small {
          &::-webkit-scrollbar {
            height: 8px !important;
          }

          &::-webkit-scrollbar-track {
            background: transparent !important;
          }

          &::-webkit-scrollbar-thumb {
            background: #888 !important;
          }
        }
        .ant-timeline {
          .ant-timeline-item {
            padding-bottom: 49px;
            .ant-timeline-item-tail {
              background-color: ${colors.primary};
            }
            .ant-timeline-item-head {
              padding: 0px;
            }
          }
        }
      `}
    />
  );
};

export default GlobalStyles;
